/** Format a USD cost for the KB cost display. LLM spend is billed in USD and is
 *  often sub-cent, so we keep precision below $0.01 rather than rounding to two
 *  decimals like the CAD recovery amounts. */
export function formatUsdCost(usd: number): string {
  if (!Number.isFinite(usd) || usd <= 0) return '$0.00';
  if (usd < 0.01) return `$${usd.toFixed(4)}`;
  return `$${usd.toFixed(2)}`;
}

/** The citation label shown on a source chip, e.g. "9-4 para 37-38". */
export function citationLabel(doc_code: string, para_range: string): string {
  return para_range ? `${doc_code} para ${para_range}` : doc_code;
}
